module.exports = __webpack_public_path__ + "img/consultative-img.8695ff17.png";